//LIBRARIES
import React, { Fragment } from 'react';
import styled from 'styled-components';

//COMPONENTS
import Select from 'components/ui/SelectField';
import Spacer from 'components/ui/Spacer';
import Form from 'components/ui/Form';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';

//HELPERS
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';

const FullWidthSelect = styled(Select)`
  width: 100%;
`;

const StyledSpacer = styled(Spacer)`
  display: flex;
  justify-content: center;
`;

const FormTitle = styled.span`
  font-size: 24px;
  font-family: 'Circular-Bold';
  color: ${colors.BLACK};
`;

const FormSubTitle = styled.span`
  font-size: 16px;
  color: ${colors.FONT_GRAY};
`;

const TicketCancelForm = ({ values, touched, errors, setFieldValue }) => {
  return (
    <Fragment>
      <StyledSpacer mb={1}>
        <FormTitle>
          {getTranslatedString('landlordPortal.maintenance.tickets.cancelDialog.header')}
        </FormTitle>
      </StyledSpacer>
      <StyledSpacer mb={1}>
        <FormSubTitle>
          {getTranslatedString('landlordPortal.maintenance.tickets.cancelDialog.subHeader')}
        </FormSubTitle>
      </StyledSpacer>
      <Spacer mb={3}>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              label={`${getTranslatedString(
                'landlordPortal.maintenance.tickets.cancelDialog.label'
              )}`}
              validateStatus={
                touched.cancellation_reason && errors.cancellation_reason ? 'error' : null
              }
              help={touched.cancellation_reason && errors.cancellation_reason}
            >
              <FullWidthSelect
                name="cancellation_reason"
                value={values.cancellation_reason}
                onChange={value => {
                  setFieldValue('cancellation_reason', value);
                }}
                placeholder={getTranslatedString(
                  'landlordPortal.maintenance.tickets.cancelDialog.placeholder'
                )}
                size="large"
              >
                <Select.Option value="cancelled">
                  {getTranslatedString('landlordPortal.ticketDetailsOverview.cancelNoIssue')}
                </Select.Option>

                <Select.Option value="cancelled_dup">
                  {getTranslatedString('landlordPortal.ticketDetailsOverview.cancelDupIssue')}
                </Select.Option>
                {featureEnabled('ui.maintenance.tickets.show_cancel_no_response') && (
                  <Select.Option value="cancelled_no_res">
                    {getTranslatedString('landlordPortal.ticketDetailsOverview.cancelNoResponse')}
                  </Select.Option>
                )}
              </FullWidthSelect>
            </Form.Item>
          </Col>
        </Row>
      </Spacer>
    </Fragment>
  );
};

export default TicketCancelForm;
